/* eslint-disable react/display-name */
import {
  Button,
  Drawer,
  Grid,
  makeStyles,
  Paper,
  TablePagination,
  Typography,
} from "@material-ui/core";
import { Cancel, FilterList } from "@material-ui/icons";
import { format } from "date-fns";
import {
  getDateTimeLocale,
  getDateFormats,
} from "../../../utils/get-date-time-locale";

import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useDeliberationList } from "../../../context/lists/deliberationList";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import { getAllDeliberations } from "../../../services/finalDeliberations.service";
import { Table } from "../../Common/Table";
import ToastMessage from "../../Common/ToastMessage";
import { checkAccess } from "../utils/index";
import ModalBase from "../utils/ModalBase";
import CustomGroupRow from "./components/CustomGroupRow";
import ExtractModal from "./components/ExtractModal";
import FilterDrawer from "./FilterDrawer";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
    width: "100%",
  },
  fullWidthContainer: {
    maxWidth: "100%",
  },
  filterButton: {
    ...theme.typography.subtitle1,
    backgroundColor: "#fff",
    color: "#666666",
    borderRadius: 8,
    border: "1px solid #666666",
    textTransform: "uppercase",
    maxWidth: 140,
    width: "100%",
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    borderRadius: 5,
    height: 50,
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const ListDeliberations = ({ i18n, t, actionShowSpinner }) => {
  const classes = useStyles();
  const history = useHistory();
  const { userAccess } = useAuth();
  const { listOptions, updateFilterParams, updatePagination } =
    useDeliberationList();

  const [toastMessage, setToastMessage] = useState({
    message: "",
    type: "error",
    open: false,
  });
  const [extractModalViewMode, setExtractModalViewMode] = useState(false);
  const [canSendExtract, setCanSendExtract] = useState(false);
  const [canSeeExtract, setCanSeeExtract] = useState(false);
  const [sendExtractError, setSendExtractError] = useState(false);
  const [formattedDeliberations, setFormattedDeliberations] = useState([]);
  const [selectedDeliberation, setSelectedDeliberation] = useState();
  const [defaultEmails, setDefaultEmails] = useState("");
  const [selectedSlot, setSelectedSlot] = useState();
  const [openDeliberationExtract, setOpenDeliberationExtract] = useState(false);
  const [filterDrawerOpened, setFilterDrawerOpened] = useState(false);
  const [totalDeliberations, setTotalDeliberations] = useState(0);
  const [sendExtractErrorMessage, setSendExtractErrorMessage] = useState("");

  useEffect(() => {
    actionShowSpinner(true);

    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "listDeliberations");
      const hasAccessToSendExtract = checkAccess(
        userAccess,
        "exportDeliberationExtract"
      );
      const hasAccessToSeeExtract = checkAccess(
        userAccess,
        "showDeliberationExtract"
      );

      setCanSendExtract(hasAccessToSendExtract);
      setCanSeeExtract(hasAccessToSeeExtract);

      if (!hasAccess) {
        history.push("/");
      }

      getAllDeliberations({
        ...(listOptions.filterParams?.requester?.id && {
          requesterId: listOptions.filterParams.requester.id,
        }),
        ...(listOptions.filterParams?.presenter?.id && {
          presenterId: listOptions.filterParams.presenter.id,
        }),
        ...(listOptions.filterParams?.directory?.id && {
          directoryId: listOptions.filterParams.directory.id,
        }),
        ...(listOptions.filterParams?.finalDeliberationStatus && {
          finalDeliberationStatus:
            listOptions.filterParams.finalDeliberationStatus.map(
              (delib) => delib.id
            ),
        }),
        ...(listOptions.filterParams?.finalAuthority?.id && {
          finalAuthority: listOptions.filterParams.finalAuthority.id,
        }),
        ...(listOptions.filterParams?.committees && {
          committees: listOptions.filterParams.committees.map(
            (committee) => committee.id
          ),
        }),
        ...(listOptions.filterParams?.companies && {
          companyIds: listOptions.filterParams.companies.map(
            (company) => company.id
          ),
        }),
        ...(listOptions.filterParams?.modality?.id && {
          modalityId: listOptions.filterParams.modality.id,
        }),
        ...(listOptions.filterParams?.startDate && {
          startDate: listOptions.filterParams.startDate,
        }),
        ...(listOptions.filterParams?.endDate && {
          endDate: listOptions.filterParams.endDate,
        }),
        ...(listOptions.filterParams?.keyword?.length &&
          listOptions.filterParams?.keyword && {
            keyword: listOptions.filterParams.keyword,
          }),
        currentPage: listOptions.pagination.page,
        pageSize: listOptions.pagination.size,
      })
        .then(({ data }) => {
          setTotalDeliberations(data.countItems);
          setFormattedDeliberations(
            data.items.map((deliberation) => ({
              id: deliberation.deliberationId,
              meetDate: deliberation.meetDate
                ? format(
                    new Date(deliberation.meetDate),
                    getDateFormats(i18n.language),
                    {
                      locale: getDateTimeLocale(i18n.language),
                    }
                  )
                : "",
              slotTheme: deliberation.theme,
              modality: deliberation.modality,
              companies: deliberation.companies,
              slotId: deliberation.slotId,
              hostsEmails: deliberation.hosts
                .map((host) => host.email)
                .join(";"),
              extractSent: deliberation.extractSent,
              presenterName: deliberation.presenterName,
              finalAuthorityName: deliberation.finalAuthorityName,
              committeeName: deliberation.committeeName,
              deliberation: deliberation.deliberation,
              finalAuthority: deliberation.finalAuthority,
              deliberation: getDeliberationName(deliberation.deliberation),
              finalDeliberation: getDeliberationName(
                deliberation.finalDeliberation
              ),
              anyoneCanHost: deliberation.anyoneCanHost,
              hosts: deliberation.hosts
                .map((host) => host.userName)
                .join(" | "),
            }))
          );
        })
        .finally(() => actionShowSpinner(false));
    }
  }, [userAccess, listOptions]);

  const getDeliberationName = (deliberation) => {
    switch (deliberation) {
      case "A":
        return t("forms.minutes.actions.approved");
      case "R":
        return t("forms.minutes.actions.reproved");
      case "AR":
        return t("forms.minutes.actions.approvedWithCaveats");
      case "ARB":
        return t("forms.minutes.actions.roudRobbinapproved");
      case "NA":
        return "N/A";
    }
  };

  const columns = [
    {
      title: "slot",
      field: "slotId",
      defaultGroupOrder: 0,
      grouping: true,
    },
    {
      title: t("forms.committeeName").toUpperCase(),
      field: "committeeName",
    },
    {
      title: t("slots.meetingDate").toUpperCase(),
      field: "meetDate",
    },
    {
      title: t("menu.finalDeliberations.info.deliberation").toUpperCase(),
      field: "deliberation",
    },
  ];

  const onSendExtractError = (message) => {
    setSendExtractError(true);
    setSendExtractErrorMessage(
      message.length > 0 ? message : t("error.sendExtract")
    );

    setTimeout(() => {
      setSendExtractError(false);
    }, 3000);
  };

  return (
    <Grid container className={classes.root}>
      <ModalBase
        open={openDeliberationExtract}
        setOpen={setOpenDeliberationExtract}
        content={
          <ExtractModal
            i18n={i18n}
            t={t}
            slotId={selectedSlot}
            onSendExtractError={onSendExtractError}
            deliberationId={selectedDeliberation}
            close={() => setOpenDeliberationExtract(false)}
            defaultEmails={defaultEmails}
            viewMode={extractModalViewMode}
          />
        }
      />
      <Drawer
        anchor="right"
        open={filterDrawerOpened}
        onClose={() => {
          setFilterDrawerOpened(false);
        }}
      >
        <FilterDrawer
          actionShowSpinner={(opened) => actionShowSpinner(opened)}
          onClose={() => {
            setFilterDrawerOpened(false);
          }}
          t={t}
          setFilters={(newValues) => {
            updateFilterParams(newValues);
            updatePagination({ ...listOptions.pagination, page: 0 });
          }}
          filters={listOptions.filterParams}
        />
      </Drawer>
      <ToastMessage
        message={toastMessage.message}
        type={toastMessage.type || "error"}
        open={toastMessage.open}
        close={() => setToastMessage({ ...toastMessage, open: false })}
      />
      <Grid item className={classes.spacer}>
        <Typography variant="h4">{t("finalDeliberations.title")}</Typography>
      </Grid>
      <Grid container item lg={12}>
        <Paper elevation={1} className={classes.root}>
          <Grid
            container
            spacing={3}
            direction="column"
            className={classes.fullWidthContainer}
          >
            <Grid item lg={3} className={classes.fullWidthContainer}>
              <Grid item lg={12}>
                <Button
                  className={classes.filterButton}
                  startIcon={<FilterList style={{ fontSize: 30 }} />}
                  onClick={() => setFilterDrawerOpened(true)}
                >
                  {t("forms.filters")}
                </Button>
              </Grid>
            </Grid>

            <Grid item lg={12} className={classes.fullWidthContainer}>
              <Table
                columns={columns}
                data={formattedDeliberations}
                pageSize={listOptions.pagination.size}
                components={{
                  GroupRow: (rowData) => {
                    return (
                      <CustomGroupRow
                        {...rowData}
                        t={t}
                        canSendExtract={canSendExtract}
                        canSeeExtract={canSeeExtract}
                        sendExtract={() => {
                          setSelectedDeliberation(
                            rowData.groupData.data.find(
                              (deliberation) =>
                                deliberation.id !==
                                "00000000-0000-0000-0000-000000000000"
                            ).id
                          );
                          setSelectedSlot(rowData.groupData.data[0].slotId);

                          setDefaultEmails(
                            rowData.groupData.data[0].hostsEmails
                          );

                          setOpenDeliberationExtract(true);
                          setExtractModalViewMode(false);
                        }}
                        showExtract={() => {
                          setSelectedDeliberation(
                            rowData.groupData.data.find(
                              (deliberation) =>
                                deliberation.id !==
                                "00000000-0000-0000-0000-000000000000"
                            ).id
                          );
                          setSelectedSlot(rowData.groupData.data[0].slotId);

                          setDefaultEmails(
                            rowData.groupData.data[0].hostsEmails
                          );

                          setOpenDeliberationExtract(true);
                          setExtractModalViewMode(true);
                        }}
                      />
                    );
                  },
                  Pagination: (props) => {
                    return (
                      <TablePagination
                        style={{ float: "right" }}
                        rowsPerPageOptions={[5, 10, 20]}
                        rowsPerPage={listOptions.pagination.size}
                        labelRowsPerPage={t("table.labelRowsPerPage")}
                        page={listOptions.pagination.page}
                        labelDisplayedRows={(_data) => {
                          let numberOfPages = Math.ceil(
                            totalDeliberations / listOptions.pagination.size
                          );

                          if (numberOfPages <= 1) {
                            numberOfPages = 1;
                          }

                          return `${listOptions.pagination.page + 1} ${t(
                            "table.labelDisplayedRows"
                          )} ${numberOfPages}`;
                        }}
                        onPageChange={(_e, page) => {
                          updatePagination({
                            page: page,
                            size: listOptions.pagination.size,
                          });
                        }}
                        onRowsPerPageChange={(event) => {
                          const newSize = event.target.value;

                          updatePagination({
                            page: 0,
                            size: newSize,
                          });

                          props.onChangeRowsPerPage(event);
                        }}
                        nextIconButtonProps={{
                          disabled:
                            listOptions.pagination.page + 1 >=
                            Math.ceil(
                              totalDeliberations / listOptions.pagination.size
                            ),
                        }}
                        backIconButtonProps={{
                          disabled: listOptions.pagination.page + 1 <= 1,
                        }}
                      />
                    );
                  },
                }}
              />

              {sendExtractError && (
                <Grid
                  container
                  item
                  direction="row"
                  alignItems="center"
                  className={classes.error}
                >
                  <Grid item>
                    <Cancel className={classes.icon} />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      {sendExtractErrorMessage.toUpperCase()}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

const withRouterListDeliberations = withRouter(ListDeliberations);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const ListDeliberationsConnect = connect(
  null,
  mapDispatchToProps
)(withRouterListDeliberations);

export default withTranslation()(ListDeliberationsConnect);
